import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=502dc51e&scoped=true"
import script from "./Destroy.vue?vue&type=script&lang=js"
export * from "./Destroy.vue?vue&type=script&lang=js"
import style0 from "./Destroy.vue?vue&type=style&index=0&id=502dc51e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502dc51e",
  null
  
)

export default component.exports